import type { CopyCatalog } from "./copyTypes";

export const HR_COPY: CopyCatalog = {
  "common.loading": "Učitavanje…",
  "common.yes": "Da",
  "common.no": "Ne",
  "common.notProvided": "Nije navedeno",
  "common.notRequired": "Nije potrebno",
  "common.requested": "Zatraženo",
  "nav.back": "Natrag",
  "nav.continue": "Nastavi",
  "nav.sendRequest": "Pošalji zahtjev",
  "nav.sending": "Slanje…",
  "alert.completeFields": "Ispunite označena polja prije nastavka.",
  "fill.filled": "Ispunjeno",
  "fill.notFound": "Nije pronađeno",
  "fill.shipmentToo": "Pošiljka također ispunjena: {detail}",
  "fill.palletMany": "paleta",

  "choose.title": "Kako želite zatražiti ponudu?",
  "choose.manual.title": "Ručni unos",
  "choose.manual.description": "Unesite podatke o pošiljci korak po korak putem vođenog obrasca.",
  "choose.manual.action": "Unesite podatke ručno",
  "choose.quickfill.title": "Quick Fill",
  "choose.quickfill.description":
    "Zalijepite podatke o pošiljci ili prenesite dokument, a mi ćemo ispuniti obrazac za vas.",
  "choose.quickfill.action": "Započni brzo ispunjavanje",

  "steps.route": "Ruta i narudžba",
  "steps.shipment": "Pošiljka",
  "steps.services": "Dodatne usluge",
  "steps.contact": "Kontakt",
  "steps.review": "Pregled",

  "page.route": "Ruta i narudžba",
  "page.routeSection": "Ruta",
  "page.shipment": "Podaci o pošiljci",
  "page.services": "Dodatne usluge",
  "page.contact": "Kontaktni podaci",
  "page.contactSection": "Vaši kontaktni podaci",
  "page.review": "Pregled",
  "page.quickFill": "Quick Fill",
  "page.analyzing": "Analiza vašeg dokumenta",

  "route.hintPostcode": "Unesite poštanski broj ili mjesto za utovar i istovar.",
  "route.hintFullAddress": "Unesite punu adresu utovara i istovara.",
  "route.unsupported": "Ova ruta nije podržana. Koristite obrazac za {loadCountry} i {unloadCountry}.",
  "route.loading": "Utovar",
  "route.unloading": "Istovar",
  "route.origin": "Polazište",
  "route.destination": "Odredište",
  "route.country": "Država",
  "route.selectCountry": "Odaberite državu",
  "route.postcode": "Poštanski broj",
  "route.postcodePlaceholder": "npr. 10000",
  "route.city": "Mjesto",
  "route.cityPlaceholder": "Unesite mjesto",
  "route.street": "Naziv ulice",
  "route.streetPlaceholder": "Unesite ulicu",
  "route.house": "Kućni broj",
  "route.housePlaceholder": "npr. 12",
  "route.pickupDate": "Željeni datum preuzimanja:",
  "route.unloadDate": "Željeni datum istovara:",
  "route.datePlaceholder": "dd.mm.gggg.",
  "date.clear": "Obriši datum",
  "date.closeCalendar": "Zatvori kalendar",
  "date.openCalendar": "Otvori kalendar",
  "route.specificDateHint":
    "Za robu dostupnu na određeni datum. Inače težimo najbržoj opciji.",
  "route.orderDetails": "Podaci o narudžbi",

  "shipment.goods": "Opis robe",
  "shipment.goodsPlaceholder": "Što želite prevesti?",
  "shipment.weight": "Ukupna masa",
  "shipment.qty": "Kol.",
  "shipment.type": "Vrsta",
  "shipment.dims": "Dimenzije / LDM",
  "shipment.stackable": "Složivo",
  "shipment.addRow": "Dodaj red pošiljke",
  "shipment.totalLines": "Ukupno redova: {count}",
  "shipment.selectDims": "Odaberite dimenzije",
  "shipment.dimsNa": "Dimenzije nisu primjenjive",
  "shipment.sizeModeDims": "D × Š × V",
  "shipment.sizeModeLdm": "LDM",
  "shipment.removeRow": "Ukloni red pošiljke {n}",
  "shipment.lineLabel": "{text}, red {n}",
  "shipment.quantity": "Količina",
  "qty.decrease": "Smanji količinu",
  "qty.increase": "Povećaj količinu",
  "shipment.lengthCm": "Duljina (cm)",
  "shipment.widthCm": "Širina (cm)",
  "shipment.heightCm": "Visina (cm)",
  "shipment.dimensions": "Dimenzije",
  "shipment.size": "Veličina",
  "shipment.ldm": "LDM",

  "pallet.euro": "Euro",
  "pallet.block": "Block",
  "pallet.ibc": "IBC",
  "pallet.cp3": "CP3",
  "pallet.half": "Polupaleta",
  "pallet.size80x60": "80×60",
  "pallet.size120x120": "120×120",
  "pallet.size150x80": "150×80",
  "pallet.custom": "Prilagođeno",
  "pallet.unspecified": "LDM",

  "services.aria": "Dodatne usluge",
  "services.pill.adr": "ADR",
  "services.pill.temp": "Temperatura",
  "services.pill.tail": "Hidraulična rampa",
  "services.pill.ftl": "FTL",
  "services.pill.time": "Vremenski prozor",
  "services.pill.ref": "Referenca / napomene",
  "services.pill.references": "Reference",
  "services.pill.attachments": "Dodatni privitci",
  "services.adrClass": "ADR razred",
  "services.selectClass": "Odaberite razred",
  "services.unNumber": "UN broj",
  "services.unPlaceholder": "npr. 1203",
  "services.min": "Min",
  "services.max": "Max",
  "services.tailLoad": "Hidraulična rampa pri utovaru",
  "services.tailUnload": "Hidraulična rampa pri istovaru",
  "services.ftlCopy": "Zatražen je puni kamion.",
  "services.invoiceRef": "Referenca računa",
  "services.reference": "Referenca",
  "services.loadingRef": "Referenca utovara",
  "services.unloadingRef": "Referenca istovara",
  "services.notes": "Napomene",
  "services.notesPlaceholder": "npr. posebne upute",
  "services.deadline": "Željeni rok isporuke:",
  "services.deliveryHint":
    "Za robu koja se mora isporučiti na određeni datum. Inače težimo najbržoj opciji.",
  "services.loadingTime": "Vrijeme utovara",
  "services.unloadingTime": "Vrijeme istovara",
  "services.window": "Prozor",
  "services.fixed": "Fiksno",
  "services.at": "u",
  "services.from": "od",
  "services.to": "do",
  "services.timeTypeAria": "Vrsta: {title}",
  "services.addFiles": "Dodaj datoteke",
  "services.attachHint":
    "JPEG, PNG, GIF, WebP ili PDF. Do {maxFiles} datoteka, {maxFileMb} MB svaka, ukupno {maxTotalMb} MB.",
  "services.adrClass1": "1 Eksplozivne tvari",
  "services.adrClass2": "2 Plinovi",
  "services.adrClass3": "3 Zapaljive tekućine",
  "services.adrClass4": "4 Zapaljive krute tvari",
  "services.adrClass5": "5 Oksidirajuće tvari",
  "services.adrClass6": "6 Otrovne / zarazne tvari",
  "services.adrClass7": "7 Radioaktivne tvari",
  "services.adrClass8": "8 Nagrizajuće tvari",
  "services.adrClass9": "9 Ostale opasne tvari",
  "services.summary.adr": "Opasna roba (ADR)",
  "services.summary.temp": "Kontrolirana temperatura",
  "services.summary.time": "Vremenski prozori",
  "services.summary.refNotes": "Referenca i napomene",
  "services.summary.tail": "Hidraulična rampa",
  "services.summary.ftl": "FTL",
  "services.summary.attachments": "Dodatni privitci",
  "services.tail.loadUnload": "Utovar i istovar",
  "services.tail.loadOnly": "Samo utovar",
  "services.tail.unloadOnly": "Samo istovar",
  "services.time.load": "Utovar: {value}",
  "services.time.unload": "Istovar: {value}",
  "services.time.deadline": "Rok: {value}",
  "services.time.fixedSuffix": "{time} (fiksno)",
  "services.time.windowRange": "{from} do {until}",
  "services.adr.yes": "Da",
  "services.adr.classUn": "Razred {class}, UN {un}",
  "services.adr.classOnly": "Razred {class}",
  "services.adr.unOnly": "UN {un}",
  "services.temp.range": "{min}°C do {max}°C",
  "services.ref.invoice": "Račun: {value}",
  "services.ref.loading": "Utovar: {value}",
  "services.ref.unloading": "Istovar: {value}",

  "contact.name": "Ime",
  "contact.company": "Tvrtka",
  "contact.email": "E-pošta",
  "contact.phone": "Telefon",
  "contact.comment": "Dodatna napomena",
  "contact.privacyBefore":
    "Slažem se s obradom mojih osobnih podataka u skladu s ",
  "contact.privacyLink": "pravilima o privatnosti",
  "contact.privacyAfter": " tvrtke Neele-Vat.",

  "result.thankYou": "Hvala! Vaš je zahtjev zaprimljen.",
  "result.teamWillContact":
    "Naš će vas tim kontaktirati unutar 60 minuta tijekom radnog vremena.",
  "result.teamWillContactEmail":
    "Naš će vas tim kontaktirati unutar 60 minuta tijekom radnog vremena na {email}.",
  "result.previewMode": "Način pretpregleda — ovaj zahtjev nije stvarno poslan.",
  "result.previewFiles": " Napomena: datoteke se ne mogu slati u načinu pretpregleda.",
  "result.yourReference": "Vaša referenca",
  "result.copy": "Kopiraj",
  "result.copied": "Kopirano",
  "result.nextTitle": "Što slijedi",
  "result.next1": "Zahtjev zaprimljen.",
  "result.next2": "Zahtjev se pregledava.",
  "result.next3": "Odgovor unutar 60 minuta e-poštom.",
  "result.logged":
    "Zabilježili smo vaš zahtjev. Ako ne dobijete obavijest, kontaktirajte nas putem podataka u nastavku.",
  "result.newQuote": "Započni novu ponudu",
  "result.sendFailed": "Nismo mogli poslati vaš zahtjev",
  "result.preferDirect": "Želite li nas kontaktirati izravno?",
  "result.backToEdit": "Natrag na uređivanje",
  "result.tryAgain": "Pokušaj ponovno",
  "result.hideDetails": "Sakrij pojedinosti",
  "result.viewSent": "Pogledajte što smo poslali",
  "result.error.rateLimited":
    "U kratkom ste vremenu poslali mnogo zahtjeva. Pričekajte trenutak i pokušajte ponovno.",
  "result.error.forbidden":
    "Ovaj je zahtjev blokiran. Pokušajte ponovno ili nas kontaktirajte izravno.",
  "result.error.network":
    "Trenutačno nismo mogli poslati vaš zahtjev. Provjerite vezu i pokušajte ponovno.",
  "result.error.tooLarge":
    "Zahtjev je prevelik za slanje. Upotrijebite manje privitke ili kraću napomenu.",
  "result.error.unsupportedType": "Koristite samo JPEG, PNG, GIF, WebP ili PDF.",
  "result.error.emailUnavailable":
    "Nismo mogli e-poštom poslati zahtjev s privicima. Pokušajte ponovno ili nas kontaktirajte izravno.",

  "qf.hint":
    "Zalijepite e-poruku ili podatke o pošiljci ili priložite sliku ili PDF. Time se zamjenjuju već uneseni podaci.",
  "qf.placeholder":
    "npr. 24 euro palete iz 3011 Rotterdama u 20095 Hamburg, 12.000 kg, preuzimanje sutra…",
  "qf.ariaPaste": "Podaci o pošiljci za analizu",
  "qf.attach": "Priloži sliku ili PDF",
  "qf.disclaimer":
    "Sve što zalijepite ili priložite koristi se samo za ispunjavanje ovog zahtjeva. Obrađuje to naša usluga analize dokumenata i ne pohranjuje se nakon ispunjavanja obrasca.",
  "qf.fillForm": "Ispuni obrazac",
  "qf.working": "Obrada…",
  "qf.analyzing": "Analiza vaših podataka…",
  "qf.noFields": "Nije prepoznato nijedno polje. Dodajte više pojedinosti.",
  "qf.rateLimited": "Poslali ste previše zahtjeva. Pričekajte trenutak i pokušajte ponovno.",
  "qf.blocked": "Ovaj je zahtjev blokiran. Kontaktirajte nas ako je to neočekivano.",
  "qf.extractUnavailable":
    "Analiza dokumenata trenutačno nije dostupna. Umjesto toga zalijepite podatke o pošiljci.",
  "qf.genericError": "Nešto je pošlo po zlu. Provjerite mrežu ili pokušajte ponovno.",
  "qf.analyzeTitle": "Analiza vašeg dokumenta...",
  "qf.analyzeSub": "To obično traje nekoliko sekundi",
  "qf.analyzeStep1": "Čitanje strukture dokumenta",
  "qf.analyzeStep2": "Izdvajanje osnovnih podataka",
  "qf.analyzeStep3": "Prepoznavanje redova pošiljke",
  "qf.removeFile": "Ukloni {name}",

  "error.loadCountry": "Odaberite državu utovara.",
  "error.loadPostal": "Unesite poštanski broj utovara.",
  "error.loadCity": "Unesite mjesto utovara.",
  "error.loadStreet": "Unesite naziv ulice utovara.",
  "error.loadHouseNumber": "Unesite kućni broj utovara.",
  "error.unloadCountry": "Odaberite državu istovara.",
  "error.unloadPostal": "Unesite poštanski broj istovara.",
  "error.unloadCity": "Unesite mjesto istovara.",
  "error.unloadStreet": "Unesite naziv ulice istovara.",
  "error.unloadHouseNumber": "Unesite kućni broj istovara.",
  "error.pickupDate": "Odaberite datum preuzimanja.",
  "error.unloadDate": "Odaberite datum istovara.",
  "error.invalidDate": "Unesite valjani datum.",
  "error.totalWeight": "Unesite ukupnu masu.",
  "error.goods": "Opišite robu.",
  "error.loadCityOrPostal": "Unesite poštanski broj ili mjesto utovara.",
  "error.unloadCityOrPostal": "Unesite poštanski broj ili mjesto istovara.",
  "error.loadPostalInvalid": "Unesite prepoznati poštanski broj utovara.",
  "error.loadCityInvalid": "Unesite prepoznato mjesto utovara.",
  "error.unloadPostalInvalid": "Unesite prepoznati poštanski broj istovara.",
  "error.unloadCityInvalid": "Unesite prepoznato mjesto istovara.",
  "error.pickupPast": "Datum preuzimanja ne smije biti u prošlosti.",
  "error.unloadPast": "Datum istovara ne smije biti u prošlosti.",
  "error.unloadBeforePickup": "Datum istovara ne smije biti prije datuma preuzimanja.",
  "error.weightRange": "Unesite masu između 1 i {max} kg.",
  "error.rangePlain": "{min}–{max}.",
  "error.rangeLdm": "{min}–{max} LDM.",
  "error.rangeCm": "{min}–{max} cm.",
  "error.adrUn": "Unesite četveroznamenkasti UN broj.",
  "error.invoiceRef": "Unesite referencu računa.",
  "error.loadingRef": "Unesite referencu utovara.",
  "error.unloadingRef": "Unesite referencu istovara.",
  "error.tempMin": "Unesite najnižu temperaturu.",
  "error.tempMax": "Unesite najvišu temperaturu.",
  "error.tempOrder": "Maksimum mora biti barem jednak minimumu.",
  "error.enterNumber": "Unesite broj.",
  "error.deliveryPast": "Rok isporuke ne smije biti u prošlosti.",
  "error.deliveryBeforePickup": "Rok isporuke ne smije biti prije datuma preuzimanja.",
  "error.tailSides": "Odaberite utovar, istovar ili oboje.",
  "error.attachOne": "Priložite barem jednu datoteku.",
  "error.enterTime": "Unesite vrijeme.",
  "error.enterStartTime": "Unesite početno vrijeme.",
  "error.enterEndTime": "Unesite završno vrijeme.",
  "error.enterMinutes": "Unesite minute.",
  "error.completeTime": "Unesite potpuno vrijeme.",
  "error.enterEmail": "Unesite adresu e-pošte.",
  "error.validEmail": "Unesite valjanu adresu e-pošte.",
  "error.validPhone": "Unesite valjani telefonski broj.",
  "error.personalEmail": "Osobne adrese e-pošte nisu prihvaćene.",
  "error.enterName": "Unesite svoje ime.",
  "error.enterCompany": "Unesite svoju tvrtku.",
  "error.privacy": "Prihvatite kako biste nastavili.",
  "error.quickFillEmpty":
    "Zalijepite podatke o pošiljci ili priložite sliku ili PDF kako biste ispunili obrazac.",
  "error.maxFiles": "Možete priložiti do {max} datoteka.",
  "error.maxFileMb": "Svaka datoteka smije imati najviše {max} MB.",
  "error.maxTotalMb": "Privitci smiju ukupno imati najviše {max} MB.",
  "error.filesSkippedType": "Neke su datoteke preskočene. Koristite JPEG, PNG, GIF, WebP ili PDF.",
  "error.emptySkipped": "Prazne su datoteke preskočene.",
  "error.fileEmpty": "Odabrana datoteka je prazna.",
  "error.filesEmptyOrType": "Neke su datoteke bile prazne ili nisu JPEG, PNG, GIF, WebP ili PDF.",
  "error.attachType": "Priložite JPEG, PNG, GIF, WebP ili PDF.",
  "error.subjectLong": "Predmet je predugačak.",
  "error.emailTextLong": "Podaci zahtjeva predugački su.",
  "error.shortenSubject": "Skratite ovu vrijednost kako bi predmet e-pošte ostao unutar {max} znakova.",
  "error.shortenBody":
    "Skratite podatke o pošiljci ili napomenu kako bi e-pošta ostala unutar {max} znakova.",

  "announce.choose": "Odaberite kako želite zatražiti ponudu",
  "announce.quickfill": "Brzo ispunjavanje: zalijepite podatke ili prenesite dokument",
  "announce.route": "Korak 1 od 5: ruta i narudžba",
  "announce.shipment": "Korak 2 od 5: podaci o pošiljci",
  "announce.services": "Korak 3 od 5: dodatne usluge",
  "announce.contact": "Korak 4 od 5: kontaktni podaci",
  "announce.review": "Korak 5 od 5: pregledajte zahtjev",
  "announce.received": "Zahtjev zaprimljen",
  "announce.sendFailed": "Nismo mogli poslati vaš zahtjev",
  "announce.sendFailedAttempt": "Nismo mogli poslati vaš zahtjev (pokušaj {n})",
  "announce.completeFields": "Ispunite označena polja prije nastavka.",
  "announce.sending": "Šaljemo vaš zahtjev…",
};
